import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const ProductUnitMaster = () => {
  const [UnitUser, setUnitUser] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      const response = await axios.get(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_unit"
      );
      setUnitUser(response.data.data);
    };

    fetchData();
  }, []);

  const deleteUser = async (userId) => {
    try {
      const response = await axios.post(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/delete_unit",
        { unit_id: userId },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.status === true) {
        setUnitUser((prevUser) =>
          prevUser.filter((user) => user.unit_id !== userId)
        );
        toast.error(response.data.message || "Data Deleted Successfully!");
        navigate("/Unit-list");
      } else {
        toast.error(response.data.error || "Delete failed.");
      }
    } catch (error) {
      console.error("There was an error!", error);
      toast.error("Failed to delete Unit.");
    }
  };


  return (
    <div className="page-content">
      <div className="container-fluid">
        {/* Page Header */}
        <div className="row mb-4">
          <div className="col-12">
            <div className="page-title-box">
              <h4 className="fw-semibold mb-0">Product Unit Master</h4>
              <ol className="breadcrumb">
                <li className="breadcrumb-item"><a href="#">Master</a></li>
                <li className="breadcrumb-item active">Product Unit</li>
              </ol>
            </div>
          </div>
        </div>

        {/* List */}
        <div className="card mt-4">
           <div className="card-header d-flex justify-content-between align-items-center">
                <h5>Unit List</h5>
                <div className="d-flex gap-2">
                  <Link to="/unit-add" className="btn btn-sm btn-blue">
                    Add Unit
                  </Link>
                </div>
              </div>
          <div className="card-body table-responsive">
            <table className="table table-bordered">
              <thead className="table-light">
                <tr>
                  <th>#</th>
                  <th>Unit Name</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {UnitUser.length > 0 ? (
                  UnitUser.map((unit, index) => (
                    <tr key={unit.unit_id}>
                      <td>{index + 1}</td>
                      <td>{unit.unit_name}</td>
                      <td>
                        <span
                          className={`badge bg-${unit.status === "active" ? "success" : "danger"}`}
                        >
                          {unit.status}
                        </span>
                      </td>
                       <td>
                            <div className="d-flex gap-2">
                              <Link
                                to={`/unit-edit/${unit.unit_id}`}
                                className="btn btn-soft-primary btn-sm"
                              >
                                <i className="fa-solid fa-pencil fs-16"></i>
                              </Link>
                              <span onClick={(e) => deleteUser(unit.unit_id)}
                                className="btn btn-soft-danger btn-sm"
                              >
                                <i className="fa-solid fa-trash fs-16"></i>
                              </span>
                            </div>
                          </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="3" className="text-center">
                      No units found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductUnitMaster;
